import { getLogger } from "@expert/logging";
import { getRootDispatcher } from "@/analytics";
import { getSelectedSessionId } from "@/sdk";
import type { SalesProvider } from "../types";
import { getProvider } from "../utils/updatePrimaryProductSaleProgress";
import { getSalesApiClient } from "./api";

const logger = getLogger({
    module: "getProductOffer",
    supportTeam: "sales",
});

export type ProductEnrollmentStatus = "FAILURE" | "INITIALIZED" | "PENDING" | "SUCCESS";

export type GetProductOfferResponse = {
    enrollmentStatus: ProductEnrollmentStatus;
    productOfferId: string;
};

export const getProductOffer = async (
    productOfferId: string,
    partner: string,
    salesProvider: SalesProvider,
): Promise<GetProductOfferResponse> => {
    const childLogger = logger.child({ sessionId: getSelectedSessionId() });
    const sessionId = getSelectedSessionId();
    try {
        const response = await getSalesApiClient()
            .get(`v3/product-offer/${partner}/${productOfferId}/${salesProvider}?sessionId=${sessionId}`, {
                retry: 0,
            })
            .json<GetProductOfferResponse>();
        if (response.enrollmentStatus === "SUCCESS" || response.enrollmentStatus === "FAILURE") {
            void getRootDispatcher().dispatchBusinessEvent(`${getProvider(salesProvider)}EnrollmentEventReceived`, {
                productOfferId: response.productOfferId,
                enrollmentStatus: response.enrollmentStatus,
            });
        }
        return response;
    } catch (err: unknown) {
        childLogger.error({ err }, `product offer poll failed`);
        throw err;
    }
};
